import {
  getAuditDetails,
  getAuditFieldInfo,
  AuditService,
  AuditActionType,
} from 'shared/userAudit/audit-constants';
import { Operation, AuditDetails } from 'data/types';
import { NatConfiguration } from 'data/natConfiguration/natConfiguration.types';

// eslint-disable-next-line import/prefer-default-export
export function getAuditDetailsToSubmit(
  natConfiguration: NatConfiguration,
  originalNatConfigurationServerData: NatConfiguration | null,
  isAuditEnabled: boolean,
  userId: string,
  userName: string,
  operation: Operation,
): AuditDetails {

  let actionType = AuditActionType.NAT_CONFIGURATION_ADD;
  let isEdit = false;
  if (operation === 'UPDATE') {
    actionType = AuditActionType.NAT_CONFIGURATION_EDIT;
    isEdit = true;
  }

  const auditDetails = getAuditDetails(
    isAuditEnabled,
    userId,
    userName,
    getAuditFieldInfo(natConfiguration, null, isEdit, originalNatConfigurationServerData),
    natConfiguration.id as string,
    AuditService.NETWORK,
    actionType,
  );
  return auditDetails as AuditDetails;
}
